$(document).ready(function () {
    initializeInputCounters();
})

window.initializeInputCounters = function () {
    function setCharCountLabel(count, container) {
        if (count >= 0) {
            container.find('.bn_active-chars-counter-label span').text(count)
        } else {
            container.find('.bn_active-chars-counter-label span').text(count)
        }
    }

    $('.bn_active-chars-counter').each(function (index, item) {
        let that = $(item),
            max = that.data('max-count'),
            input = that.find('.bn_active-chars-counter-input'),
            count = max - input.val().length;

        setCharCountLabel(count, that);

        input.on('change keyup paste', function () {
            let count = max - $(this).val().length;
            setCharCountLabel(count, that);
        });
    });
}